import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

const getColor = (theme, secondaryNav: boolean) => {
  if (secondaryNav) {
    return theme.colors.headerSecondaryNavDropdown;
  }

  return theme.colors.headerDropdown;
};

const getHoverColor = (theme, secondaryNav: boolean) => {
  if (secondaryNav) {
    return theme.colors.headerSecondaryNavDropdownHover;
  }

  return theme.colors.headerDropdownHover;
};

const getFontStyle = (theme, secondaryNav: boolean) => {
  if (secondaryNav) {
    return theme.fonts.headerSecondaryNavDropdown;
  }

  return theme.fonts.headerNavDropdown;
};

const getHoverFontStyle = (theme, secondaryNav: boolean) => {
  if (secondaryNav) {
    return theme.fonts.headerSecondaryNavDropdownHover;
  }

  return theme.fonts.headerNavDropdownHover;
};

interface LinkProps {
  selected?: boolean;
  secondaryNav?: boolean;
  children?: ReactNode;
}

export const Link = styled(NavLink)<LinkProps>(({ theme, selected, secondaryNav }) => {
  const fontHoverStyle = getHoverFontStyle(theme, secondaryNav);
  const fontStyle = selected
    ? {
        ...fontHoverStyle,
        color: fontHoverStyle?.color || theme.palette.text.primary,
      }
    : getFontStyle(theme, secondaryNav);

  return css`
    width: 100%;
    padding: 10px 16px;
    transition: all 0.3s linear;
    color: ${({ theme }) => theme.palette.text.secondary};

    border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};

    color: ${fontStyle?.color};
    font-family: ${fontStyle?.fontFamily};
    font-size: ${fontStyle?.fontSize};
    font-weight: ${fontStyle?.fontWeight};
    font-style: ${fontStyle?.fontStyle};
    text-decoration: ${fontStyle?.textDecoration};

    &:hover {
      color: ${fontHoverStyle?.color || theme.palette.text.primary};
      font-family: ${fontHoverStyle?.fontFamily};
      font-size: ${fontHoverStyle?.fontSize};
      font-weight: ${fontHoverStyle?.fontWeight};
      font-style: ${fontHoverStyle?.fontStyle};
      text-decoration: ${fontHoverStyle?.textDecoration};
    }
  `;
});

interface WrapperProps {
  selected?: boolean;
  secondaryNav?: boolean;
  hiddenOnSmall?: boolean;
  children?: ReactNode;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme, selected, secondaryNav, hiddenOnSmall }) => css`
    display: flex;
    background-color: ${selected
      ? getHoverColor(theme, secondaryNav)
      : getColor(theme, secondaryNav)};
    min-width: max-content;

    &:hover {
      background-color: ${getHoverColor(theme, secondaryNav)};
    }

    @media (min-width: 1280px) {
      ${hiddenOnSmall &&
      css`
        display: none;
      `}
    }
  `
);

interface IconNavItemProps {
  children?: ReactNode;
}

export const IconNavItem = styled.div<IconNavItemProps>`
  display: flex;
  align-items: center;

  & svg {
    margin-right: 5px;
    font-size: inherit;
  }
`;
